import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';
import { BuildingComplexesService } from '@/services/building-complexes.service';

export class EmployeesService extends EntityService {
  static get entity() {
    return 'employees';
  }

  static async export(params = {}) {
    try {
      return await this.request().get(`${this.entity}-export`, {
        params,
        responseType: 'arraybuffer'
      });
    } catch (error) {
      throw new ErrorWrapper(error, 'Export file loading failed');
    }
  }

  static async updateContacts(id, data = {}) {
    try {
      const response = await this.request({ auth: true }).patch(
        `${this.entity}/${id}/contacts`,
        data
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async updateAdditionalInfo(id, data = {}) {
    try {
      const response = await this.request({ auth: true }).patch(
        `${this.entity}/${id}/additional-info`,
        data
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async updateInfo(id, data = {}) {
    try {
      const response = await this.request({ auth: true }).patch(
        `${this.entity}/${id}/abacus_information`,
        data
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async updateUser(id, data = {}) {
    try {
      const response = await this.request({ auth: true }).patch(
        `${this.entity}/${id}/user`,
        data
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getApprovedVacations(id) {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/${id}/approved-vacation`
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
}
